<template>
  <div class="bottom-navigation flexbox-mobile-only">
  <div class="container-fluid wrap">
    <div class="row middle-xs around-xs center-xs bottom-navigation--items">
      <SidebarLink
        v-for="item in actions"
        :key="item.name"
        :name="item.name"
        :hasBadge="item.hasBadge"
        :badgeLabel="item.badgeLabel"
        :title="item.title"
      >
        <component :is="item.slot"/>
      </SidebarLink>
    </div>
  </div>
  </div>
</template>
<script>
import SidebarLink from '../SidebarLink.vue';
import actionIcons from '../../mixins/actionIcons';

export default {
  name: 'BottomNavigation',
  mixins: [actionIcons],
  components: {
    SidebarLink,
  },
  computed: {
    actions() {
      return this.actionIcons.filter((action) => !action.excludeBottomNavigation);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint";
.bottom-navigation {
  background: var(--header-sticky-container-background, var(--c-white));
  border-top: 1px solid var(--_c-light-primary);
  width: 100%;
  position: sticky;
  bottom: 0;
  &--items {
    height: var(--bottom-navigation-height, 3.75rem);
  }
}
</style>
